import React, { useState } from 'react';
import { useCategorias } from '../context/CategoriasContext';
import { crearCategoria, actualizarCategoria, eliminarCategoria, contarProductosDeCategoria } from '../services/categoriasService';
import { mensajeAmigable } from '../utils/errores';
import { useToast } from '../context/ToastContext';

// Emojis sugeridos para categorías, agrupados por rubro (sirve para cualquier
// tipo de negocio: moda, belleza, comida, tecnología, mascotas, etc.).
export const EMOJIS = [
  '📦','🏷️','🛍️','🎁','⭐','🔥','✨','💜',
  '👗','👚','👕','👖','🧥','🩱','🩲','🧦','👙','🥻','🧣','🧤',
  '👠','👡','👢','👞','👟','🩴',
  '👜','👛','🎒','💼','🧳','👝',
  '💍','💎','📿','⌚','👑','🕶️',
  '💄','💅','💋','🧴','🧼','🪞','🧖','🌸','🌺','💐',
  '🧸','🍼','👶','🎈',
  '🏠','🛋️','🕯️','🧺','🍽️','🛏️','🪴',
  '🍰','🧁','🍪','☕','🍔','🍕','🥤','🍫','🍬','🍞',
  '🍗','🐔','🥩','🥚','🧀','🥦','🍎','🐟',
  '📱','💻','🎧','🔌','🎮','🖥️',
  '🏃','🏋️','💪','🧘','⚽','🚴',
  '🐶','🐱','🐾','🐦',
  '📚','✏️','🎨','📒','🖊️',
];

// Sugerencias de emoji por palabra clave en el nombre de la categoría.
const SUGERENCIAS = [
  { claves: ['pijama', 'dormir', 'noche'], emojis: ['🩱', '👚', '🛏️', '😴'] },
  { claves: ['interior', 'lenceria', 'lencería', 'bra', 'brasier', 'brassier', 'panty', 'pantie', 'tanga', 'boxer', 'bóxer', 'calzon', 'calzón'], emojis: ['🩲', '🩱', '👙'] },
  { claves: ['zapato', 'calzado', 'tacon', 'tacón', 'tenis', 'sandalia', 'bota', 'chancla'], emojis: ['👠', '👟', '👞', '👡', '👢', '🩴'] },
  { claves: ['dama', 'mujer', 'blusa', 'vestido', 'falda', 'femenin'], emojis: ['👗', '👚', '👛'] },
  { claves: ['caballero', 'hombre', 'varon', 'varón', 'camisa'], emojis: ['👔', '👕', '👖'] },
  { claves: ['ropa', 'camiseta', 'playera', 'pantalon', 'pantalón', 'jean', 'short', 'sueter', 'suéter'], emojis: ['👕', '👖', '👗', '🧥'] },
  { claves: ['deport', 'gym', 'fitness', 'ejercicio'], emojis: ['🏃', '🏋️', '👟', '💪'] },
  { claves: ['bebe', 'bebé', 'niño', 'nino', 'niña', 'nina', 'infantil', 'kids'], emojis: ['🧸', '👶', '🍼', '🎈'] },
  { claves: ['cartera', 'bolso', 'bolsa', 'mochila', 'maleta', 'monedero'], emojis: ['👜', '👛', '🎒', '🧳'] },
  { claves: ['joyer', 'joya', 'anillo', 'collar', 'arete', 'reloj', 'pulsera'], emojis: ['💍', '💎', '📿', '⌚'] },
  { claves: ['belleza', 'maquillaje', 'cosmetic', 'cosmétic', 'labial', 'makeup'], emojis: ['💄', '💅', '💋'] },
  { claves: ['fragancia', 'perfume', 'locion', 'loción', 'splash', 'crema', 'cuerpo'], emojis: ['🌸', '🧴', '💐'] },
  { claves: ['accesorio', 'lentes', 'gafas', 'gorra', 'sombrero', 'bufanda'], emojis: ['🕶️', '🧢', '👑', '🧣'] },
  { claves: ['comida', 'postre', 'pastel', 'reposteria', 'repostería', 'dulce', 'snack', 'galleta'], emojis: ['🍰', '🧁', '🍪', '🍬'] },
  { claves: ['pollo', 'gallina', 'avicola', 'avícola', 'pechuga', 'ala', 'muslo'], emojis: ['🍗', '🐔'] },
  { claves: ['carne', 'res', 'cerdo', 'embutido', 'chorizo', 'jamon', 'jamón'], emojis: ['🥩', '🍖'] },
  { claves: ['huevo'], emojis: ['🥚'] },
  { claves: ['lacteo', 'lácteo', 'queso', 'leche', 'mantequilla'], emojis: ['🧀', '🥛'] },
  { claves: ['bebida', 'cafe', 'café', 'jugo', 'refresco'], emojis: ['☕', '🥤', '🧃'] },
  { claves: ['hogar', 'casa', 'decoracion', 'decoración', 'cocina', 'mueble'], emojis: ['🏠', '🛋️', '🍽️', '🕯️'] },
  { claves: ['tecnolog', 'celular', 'telefono', 'teléfono', 'electronic', 'electrónic', 'audifono', 'audífono', 'accesorio de celular'], emojis: ['📱', '💻', '🎧', '🔌'] },
  { claves: ['mascota', 'perro', 'gato', 'animal'], emojis: ['🐶', '🐱', '🐾'] },
  { claves: ['libro', 'papeleria', 'papelería', 'escolar', 'util', 'útil', 'oficina'], emojis: ['📚', '✏️', '🎨'] },
  { claves: ['flor', 'floreria', 'florería', 'ramo'], emojis: ['💐', '🌹', '🌸'] },
  { claves: ['limpieza', 'aseo', 'jabon', 'jabón'], emojis: ['🧼', '🧴', '🧺'] },
];

const normalizar = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

export function sugerirEmojis(nombre) {
  const n = normalizar(nombre);
  if (!n) return [];
  const fuera = new Set();
  SUGERENCIAS.forEach((g) => {
    if (g.claves.some((c) => n.includes(normalizar(c)))) g.emojis.forEach((e) => fuera.add(e));
  });
  return [...fuera].slice(0, 8);
}

// Selector de emojis: botón que abre una lista para elegir con un clic. Si el
// nombre de la categoría da pistas, SUGIERE emojis acordes arriba de la lista.
// `arriba`: abre el panel hacia arriba (para el formulario del fondo del modal).
export function SelectorEmoji({ value, onChange, disabled, nombre, arriba }) {
  const [abierto, setAbierto] = useState(false);
  const sugeridos = sugerirEmojis(nombre);
  const posicion = arriba ? { bottom: '44px' } : { top: '44px' };
  return (
    <div style={{ position: 'relative', flexShrink: 0 }}>
      <button type="button" disabled={disabled} onClick={() => setAbierto((v) => !v)}
        title="Elegir emoji"
        style={{ width: '48px', height: '40px', border: '1px solid #D1D5DB', borderRadius: '6px', fontSize: '18px', cursor: disabled ? 'default' : 'pointer', background: 'white', lineHeight: 1 }}>
        {value || '😀'}
      </button>
      {abierto && (
        <>
          <div onClick={() => setAbierto(false)} style={{ position: 'fixed', inset: 0, zIndex: 40 }} />
          <div style={{ position: 'absolute', zIndex: 41, left: 0, ...posicion, background: 'white', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '10px', boxShadow: '0 12px 30px rgba(0,0,0,0.18)', width: '308px' }}>
            {sugeridos.length > 0 && (
              <div style={{ marginBottom: '10px' }}>
                <p style={{ margin: '0 0 5px', fontSize: '11px', fontWeight: 700, color: 'var(--color-primario,#DB2777)' }}>
                  ✨ Sugeridos para "{nombre}"
                </p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px' }}>
                  {sugeridos.map((e) => (
                    <button key={e} type="button" onClick={() => { onChange(e); setAbierto(false); }}
                      style={{ fontSize: '22px', padding: '5px 7px', border: '1px solid #F3E8FF', background: '#FAF5FF', borderRadius: '9px', cursor: 'pointer', lineHeight: 1 }}>
                      {e}
                    </button>
                  ))}
                </div>
                <div style={{ borderTop: '1px solid #F3F4F6', margin: '10px 0 6px' }} />
                <p style={{ margin: '0 0 6px', fontSize: '11px', fontWeight: 600, color: '#9CA3AF' }}>O elige otro:</p>
              </div>
            )}
            <input autoFocus type="text" maxLength={4} value={value}
              onChange={(e) => onChange(e.target.value)} placeholder="Pegá o escribe tu emoji…"
              style={{ width: '100%', padding: '7px 9px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', marginBottom: '8px', boxSizing: 'border-box' }} />
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: '2px', maxHeight: '176px', overflowY: 'auto' }}>
              {EMOJIS.map((e) => (
                <button key={e} type="button" onClick={() => { onChange(e); setAbierto(false); }}
                  style={{ fontSize: '20px', padding: '5px 0', border: 'none', background: value === e ? '#F3E8FF' : 'none', borderRadius: '7px', cursor: 'pointer', lineHeight: 1 }}>
                  {e}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default function GestionCategorias({ onCerrar }) {
  const { categorias, recargar } = useCategorias();
  const { mostrarToast } = useToast();
  const [ocupado, setOcupado] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [formEdicion, setFormEdicion] = useState({ nombre: '', icono: '' });
  const [nueva, setNueva] = useState({ nombre: '', prefijo: '', icono: '' });
  const [confirmandoId, setConfirmandoId] = useState(null);

  const agregar = async () => {
    if (!nueva.nombre.trim()) { mostrarToast('El nombre es obligatorio', 'error'); return; }
    if (!nueva.prefijo.trim() || !/^[A-Za-z]{2,4}$/.test(nueva.prefijo.trim())) {
      mostrarToast('El prefijo debe tener 2 a 4 letras (ej. RI, CAL)', 'error');
      return;
    }
    setOcupado(true);
    try {
      const orden = Math.max(0, ...categorias.map((c) => c.orden || 0)) + 1;
      await crearCategoria({ ...nueva, icono: nueva.icono.trim() || '📦', orden });
      mostrarToast(`Categoría "${nueva.nombre}" creada ✅`, 'exito');
      setNueva({ nombre: '', prefijo: '', icono: '' });
      recargar();
    } catch (e) {
      const msg = (e?.message || '').includes('duplicate')
        ? 'Ya existe una categoría con ese nombre o prefijo.'
        : mensajeAmigable(e);
      mostrarToast(msg, 'error');
    } finally {
      setOcupado(false);
    }
  };

  const guardarEdicion = async (cat) => {
    if (!formEdicion.nombre.trim()) { mostrarToast('El nombre es obligatorio', 'error'); return; }
    setOcupado(true);
    try {
      await actualizarCategoria(cat.id, {
        nombre: formEdicion.nombre,
        icono: formEdicion.icono.trim() || '📦',
        nombreAnterior: cat.nombre,
      });
      mostrarToast('Categoría actualizada ✅', 'exito');
      setEditandoId(null);
      recargar();
    } catch (e) {
      mostrarToast(mensajeAmigable(e), 'error');
    } finally {
      setOcupado(false);
    }
  };

  const eliminar = async (cat) => {
    setOcupado(true);
    try {
      const enUso = await contarProductosDeCategoria(cat.nombre);
      if (enUso > 0) {
        mostrarToast(`No se puede eliminar: ${enUso} producto(s) usan "${cat.nombre}". Cámbialos de categoría primero.`, 'error', 6000);
        setConfirmandoId(null);
        return;
      }
      await eliminarCategoria(cat.id);
      mostrarToast(`Categoría "${cat.nombre}" eliminada 🗑️`, 'exito');
      setConfirmandoId(null);
      recargar();
    } catch (e) {
      mostrarToast(mensajeAmigable(e), 'error');
    } finally {
      setOcupado(false);
    }
  };

  return (
    <div onClick={onCerrar} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: 'white', borderRadius: '16px', padding: '24px', width: '560px', maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ margin: 0, color: 'var(--color-primario,#DB2777)' }}>⚙️ Categorías</h2>
          <button onClick={onCerrar} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>✕</button>
        </div>

        {categorias.map((cat) => (
          <div key={cat.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px', borderBottom: '1px solid #F3F4F6' }}>
            {editandoId === cat.id ? (
              <>
                <SelectorEmoji value={formEdicion.icono} disabled={ocupado} nombre={formEdicion.nombre}
                  onChange={(v) => setFormEdicion({ ...formEdicion, icono: v })} />
                <input value={formEdicion.nombre} disabled={ocupado}
                  onChange={(e) => setFormEdicion({ ...formEdicion, nombre: e.target.value })}
                  style={{ flex: 1, padding: '8px', border: '1px solid #D1D5DB', borderRadius: '6px', fontSize: '14px' }} />
                <button onClick={() => guardarEdicion(cat)} disabled={ocupado} style={{ padding: '8px 12px', backgroundColor: 'var(--k-verde)', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px' }}>✓</button>
                <button onClick={() => setEditandoId(null)} disabled={ocupado} style={{ padding: '8px 12px', backgroundColor: '#E5E7EB', color: '#374151', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px' }}>✕</button>
              </>
            ) : confirmandoId === cat.id ? (
              <>
                <span style={{ flex: 1, fontSize: '13px', color: '#991B1B', fontWeight: 600 }}>¿Eliminar "{cat.nombre}"?</span>
                <button onClick={() => eliminar(cat)} disabled={ocupado} style={{ padding: '8px 12px', backgroundColor: '#DC2626', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px' }}>
                  {ocupado ? '⏳' : 'Sí, eliminar'}
                </button>
                <button onClick={() => setConfirmandoId(null)} disabled={ocupado} style={{ padding: '8px 12px', backgroundColor: '#E5E7EB', color: '#374151', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px' }}>No</button>
              </>
            ) : (
              <>
                <span style={{ fontSize: '20px', width: '32px', textAlign: 'center' }}>{cat.icono}</span>
                <span style={{ flex: 1, fontSize: '14px', fontWeight: 600, color: '#111827' }}>{cat.nombre}</span>
                <span style={{ fontSize: '12px', color: '#6B7280', backgroundColor: '#F3F4F6', padding: '2px 8px', borderRadius: '999px' }}>{cat.prefijo}</span>
                <button onClick={() => { setEditandoId(cat.id); setFormEdicion({ nombre: cat.nombre, icono: cat.icono }); }}
                  style={{ padding: '6px 10px', background: 'none', border: '1px solid #D1D5DB', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>✏️</button>
                <button onClick={() => setConfirmandoId(cat.id)}
                  style={{ padding: '6px 10px', background: 'none', border: '1px solid #FCA5A5', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', color: '#DC2626' }}>🗑️</button>
              </>
            )}
          </div>
        ))}

        <div style={{ marginTop: '16px', padding: '12px', backgroundColor: '#FFF5F7', borderRadius: '8px', border: '1px solid #FBCFE8' }}>
          <p style={{ margin: '0 0 8px', fontSize: '13px', fontWeight: '600', color: 'var(--color-primario,#DB2777)' }}>➕ Nueva categoría</p>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <SelectorEmoji value={nueva.icono} disabled={ocupado} nombre={nueva.nombre} arriba
              onChange={(v) => setNueva({ ...nueva, icono: v })} />
            <input placeholder="Nombre (ej. Pijamas)" value={nueva.nombre} disabled={ocupado}
              onChange={(e) => setNueva({ ...nueva, nombre: e.target.value })}
              style={{ flex: 1, minWidth: '150px', padding: '8px', border: '1px solid #D1D5DB', borderRadius: '6px', fontSize: '14px' }} />
            <input placeholder="Prefijo (ej. PJ)" value={nueva.prefijo} disabled={ocupado} maxLength={4}
              onChange={(e) => setNueva({ ...nueva, prefijo: e.target.value.toUpperCase() })}
              style={{ width: '110px', padding: '8px', border: '1px solid #D1D5DB', borderRadius: '6px', fontSize: '14px' }} />
            <button onClick={agregar} disabled={ocupado}
              style={{ padding: '8px 16px', backgroundColor: ocupado ? '#9CA3AF' : 'var(--color-primario,#DB2777)', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px' }}>
              {ocupado ? '⏳' : 'Agregar'}
            </button>
          </div>
          <p style={{ margin: '8px 0 0', fontSize: '11px', color: '#9CA3AF' }}>
            El prefijo se usa para los códigos de producto (ej. PJ-0001). No se puede cambiar después.
          </p>
        </div>
      </div>
    </div>
  );
}
